import { createReducer, on } from '@ngrx/store';
import { CommonActions } from './common.actions';
import { initialCommonState } from './common.state';

export const commonReducer = createReducer(
    initialCommonState,

    on(CommonActions.loadMasterData, state => ({ ...state, loading: true, error: null })),
    on(CommonActions.loadMasterDataSuccess, (state, { masterData }) =>
        ({ ...state, masterData, masterDataLoaded: true, loading: false })),
    on(CommonActions.loadMasterDataFailure, (state, { error }) =>
        ({ ...state, loading: false, error })),

    on(CommonActions.loadBusinessEntities, state => ({ ...state, loading: true, error: null })),
    on(CommonActions.loadBusinessEntitiesSuccess, (state, { businessEntities }) =>
        ({ ...state, businessEntities, businessEntitiesLoaded: true, loading: false })),
    on(CommonActions.loadBusinessEntitiesFailure, (state, { error }) =>
        ({ ...state, loading: false, error })),

    on(CommonActions.loadAllUsersSuccess, (state, { users }) => ({ ...state, allUsers: users })),
    on(CommonActions.loadAllInternalUsersSuccess, (state, { users }) => ({ ...state, allInternalUsers: users })),
    on(CommonActions.loadAllRolesSuccess, (state, { roles }) => ({ ...state, allRoles: roles })),
    on(CommonActions.loadAllAESuccess, (state, { ae }) => ({ ...state, allAE: ae })),
    on(CommonActions.loadAllRecSuccess, (state, { rec }) => ({ ...state, allRec: rec })),
    on(CommonActions.loadAllTeamLeadSuccess, (state, { leads }) => ({ ...state, allTeamLead: leads })),
    on(CommonActions.loadAllClientsSuccess, (state, { clients }) => ({ ...state, allClients: clients })),
    on(CommonActions.loadQBUsersSuccess, (state, { users }) => ({ ...state, qbUsers: users })),
    on(CommonActions.loadAllCurrencySuccess, (state, { currency }) => ({ ...state, allCurrency: currency })),

    on(CommonActions.loadAllUsersFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadAllInternalUsersFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadAllRolesFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadAllAEFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadAllRecFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadAllTeamLeadFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadAllClientsFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadQBUsersFailure, (state, { error }) => ({ ...state, error })),
    on(CommonActions.loadAllCurrencyFailure, (state, { error }) => ({ ...state, error })),
);
